/**
 * Elezione vincitore «pulita»: un solo leader ai massimi voti.
 * Se tutti a zero o più partecipanti hanno lo stesso massimo (parità) → nessun vincitore.
 *
 * Nota: il codice server (`api/_lib/finalizeRound.ts`) usa la copia in `api/_lib/pickUniqueVoteLeader.ts`
 * perché il deploy Vercel non include la cartella `src/` nelle funzioni API.
 */
export function pickUniqueVoteLeader<T extends { votes: number }>(participants: readonly T[]): T | null {
  if (participants.length === 0) return null;
  const maxVotes = Math.max(0, ...participants.map((p) => p.votes));
  if (maxVotes === 0) return null;
  const leaders = participants.filter((p) => p.votes === maxVotes);
  return leaders.length === 1 ? leaders[0]! : null;
}
